import moment from 'moment-timezone';
import Bowser from 'bowser';
import {
  chatbotApiUrl,
  chatbotFileUploadUrl,
  chatbotFormKey,
  chatbotSystemId,
  chatbotScreenshotFormat,
} from '../constants/AppConstants';
import { ctaClick } from './trackingUtil';
import { UBA_EVENT_NAMES } from '../constants/Constants';

const getClientSystemDetails = () => {
  const { getParser } = Bowser;
  const { parsedResult } = getParser(window.navigator.userAgent);
  const url = window.location.href;

  return {
    browser: `${parsedResult.browser.name} (${parsedResult.browser.version})`,
    os: parsedResult.os.name,
    device: parsedResult.platform.type,
    url,
    timestamp: new Date().toLocaleString(),
  };
};

const chatBotConfig = params => {
  return {
    apiConfig: {
      apiUrl: chatbotApiUrl,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      params: {
        redirectLink: null,
        context: {},
        domain: 'Doselect',
        utmSource: null,
        utmCampaign: null,
        name: null,
        email: null,
        phone: null,
        src_tmp: '',
        channel: 'web',
        status: 'Returning',
        localStorage: 'True',
        deviceType: 'WEB',
        ...params,
      },
    },
    desktop: {
      drawer: {
        defaultOpen: false,
        backdrop: true,
        direction: 'right',
        close: {
          esc: true,
          cross: false,
          outside: true,
        },
      },
      floatingButton: {
        addFloatButton: true,
        direction: 'right',
        buttonText:
          '<div class="btn-FloatText"><span class="chatText">Hi, I am your personal assistant. </span><button class="skip" id="chatSkip">Skip</button> <button class="next btn btn-primary">Next</button></div>',
      },
    },
    callbacks: {
      onActionCb: {
        TAKE_SS: () => {
          ctaClick({
            eventName: UBA_EVENT_NAMES.chatbotClick,
            payload: {
              label: 'Report issue with screenshot',
              cta: 'Report issue with screenshot',
              source: 'chatbot',
            },
          });

          const options = {
            filter: domNode => {
              let isNodeRequired = true;
              document.querySelectorAll('video').forEach(node => {
                if (node === domNode) isNodeRequired = false;
              });

              return (
                isNodeRequired &&
                domNode !== document.getElementsByClassName('logo')?.[0]
              );
            },
            imageFormat: chatbotScreenshotFormat,
            formKey: chatbotFormKey,
            systemid: chatbotSystemId,
            context: getClientSystemDetails(),
          };

          window.nkChatBotUtility?.takeScreenShot(document.body, true, options);
        },
      },
    },
    navBarControls: [
      {
        name: 'Main Menu',
        value: 'Main Menu',
        type: 'text',
        style: {
          'font-weight': 500,
          'font-size': '14px',
          'line-height': '14px',
          color: '#8292B4',
        },
        spaceBetween: 10,
        icon: 'restart',
      },
      {
        type: 'icon',
        name: 'close',
        spaceBetween: 10,
      },
    ],
    tracking: {
      ga: {
        view: {
          defaultDataLayerObj: [],
          extDataLayerObj: {},
        },
        click: {
          defaultDataLayerObj: [],
          extDataLayerObj: {},
        },
      },
      uba: {
        view: {
          pageName: 'dashboard',
          eventName: 'widgetView',
          keyNames: {
            actionType: 'view',
            widgetName: ['chatBot'],
          },
        },
        click: {
          pageName: 'dashboard',
          eventName: 'widgetClick',
          keyNames: {
            actionType: 'click',
            widgetName: 'chatBot',
          },
          extraParms: {
            onInputClick: 'inputField',
            onCrossClick: 'crossButton',
            onClickOutside: 'clickOutside',
          },
        },
      },
    },
    uploader: {
      fileUploadUrl: chatbotFileUploadUrl,
    },
    naukriLogo: false,
    chat: [],
    delaybetweenMsgs: 1500,
    initResponse: null,
  };
};

export const showWelcomeMessage = () => {
  const chatOverlay = document.getElementsByClassName('chatbot_Overlay')[0];
  const chatBotContainer = document.getElementsByClassName('chatbot_Drawer')[0];
  let elWelcomeText = null;
  const welcome = document.getElementsByClassName('floatTextRight');
  if (welcome.length !== 0) {
    [elWelcomeText] = welcome;
    elWelcomeText?.classList.add('welcome-text-override');
  }
  chatBotContainer?.classList.remove('chatbot_Hidden');
  chatOverlay?.classList.remove('chatbot_Hide');
  const skip = document.getElementsByClassName('skip');
  const next = document.getElementsByClassName('next');
  if (skip.length !== 0) {
    skip[0].addEventListener('click', function(event) {
      event.preventDefault();
      event.stopPropagation();
      elWelcomeText?.classList.remove('welcome-text-override');
      chatOverlay?.classList.add('chatbot_Hide');
      chatBotContainer?.classList.add('chatbot_Hidden');
      document.cookie = `chatbotMounted=true`;
    });
  }
  if (next.length !== 0) {
    next[0].addEventListener('click', function() {
      document.cookie = `chatbotMounted=true`;
    });
  }
};

export default chatBotConfig;

export const getDateTime = isoDate => {
  const date = moment(isoDate);
  const formattedDate = date.format('DD-MM-YYYY');
  const formattedTime = date.format('hh:mm');
  return { formattedDate, formattedTime };
};

export const getCookie = () => {
  const cookie = {};
  document.cookie.split(';').forEach(el => {
    const [key, value] = el.split('=');
    cookie[key.trim()] = value;
  });
  return cookie;
};

export const getChatBotExtraParams = (test, user) => {
  const startDate = test.start_time ? getDateTime(test.start_time) : null;
  const endDate = test.end_time ? getDateTime(test.end_time) : null;

  return {
    testName: test.name,
    company: test.company.name,
    candidateName: user?.full_name,
    candidateEmail: user?.email,
    slug: test.slug,
    startDate: startDate ? startDate.formattedDate : '',
    startTime: startDate ? startDate.formattedTime : '',
    endDate: endDate ? endDate.formattedDate : '',
    endTime: endDate ? endDate.formattedTime : '',
  };
};
